import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container } from './styles';
import { ImpactAnalysis } from '../../../components/SliderScaleQuestions/sliderScaleQuestions';
import api from '../../../services/api';

type Item = {
  value: number;
  [key: string]: any; // others irrelevants for calculations fields
};

interface Rows {
  questionId: number;
  text: string;
  value: number;
}
interface Matrix {
  columns: any[];
  countInProgress: boolean;
  hideNumber?: boolean;
  matrixId: number;
  name: string;
  rows: Rows[];
  title: string;
  type: string;
}

interface OutputQuestion {
  questionId: number;
  questionText: string;
  average: number;
}

const colors = [
  '#F8B84E',
  '#7BC47F',
  '#A083D2',
  '#E57373',
  '#4DB6AC',
  '#FFD54F',
  '#64B5F6',
  '#BA68C8',
  '#81C784',
  '#FF8A65',
  '#9575CD',
  '#4DD0E1',
  '#AED581',
  '#FFB74D',
  '#7986CB',
  '#4FC3F7',
  '#F06292',
  '#DCE775',
  '#4DB6AC',
  '#E57373',
  '#90CAF9',
  '#CE93D8',
  '#A5D6A7',
  '#FFF176',
  '#FF7043',
  '#81D4FA',
  '#F48FB1',
  '#AED581',
  '#FFEB3B',
  '#64B5F6',
];

const MatrixChart: React.FC = () => {
  const params = useParams();
  const { surveyId } = params;

  const [listMatrixes, setListMatrix] = useState<Matrix[]>([]);
  const [dataChart, setDataChart] = useState<any>();
  const [title, setTitle] = useState<string>('');
  const [dataResults, setDataResults] = useState<any>();

  const handleGetSurvey = useCallback(async () => {
    if (surveyId !== undefined && +surveyId > 0) {
      api.get(`/surveys/${surveyId}`).then(response => {
        if (response.data) {
          setTitle(
            `${response.data.projectName} - ${response.data.name} - ${response.data.subGroup}`,
          );

          const elements = response.data.pages?.flatMap(x => {
            return x.elements;
          });

          const matrixes = elements.filter(
            x => x.type === 'matrix' && x.columns.length === 5,
          );
          setListMatrix(matrixes);
        }
      });
    }
  }, [surveyId]);

  useEffect(() => {
    api.get(`results/getResultsMatrix/${surveyId}`).then(response => {
      if (response.data && response.data.length > 0) {
        setDataResults(response.data);
      }
    });
  }, [surveyId]);

  useEffect(() => {
    handleGetSurvey();
  }, [handleGetSurvey]);

  useEffect(() => {
    function calcAverage(arr: Item[]): number {
      if (arr.length === 0) return 0; // evita divisão por zero
      const soma = arr.reduce((acc, item) => acc + item.value, 0);
      return soma / arr.length;
    }

    if (listMatrixes && dataResults) {
      const dataChartAux: any = listMatrixes.map((m, index) => {
        const questionsMatrix = m.rows.map(r => {
          const valueForThisQuestion = dataResults.filter(
            dtresult =>
              dtresult.questionId === Math.floor(Number(r.questionId)),
          );

          const a = {
            average: calcAverage(valueForThisQuestion),
            questionId: r.questionId,
            questionText: r.text,
          };

          return a;
        });

        return {
          groupId: index,
          groupName: m.name,
          questions: questionsMatrix,
          color: index < 30 ? colors[index] : colors[index - 30],
        };
      });

      setDataChart(dataChartAux);
    }
  }, [dataResults, listMatrixes]);

  return (
    <Container>
      <h1>Chart Matrixes</h1>
      <h2>{title}</h2>

      {dataChart && (
        <div style={{ marginTop: '20px' }}>
          <ImpactAnalysis data={dataChart} />
        </div>
      )}
    </Container>
  );
};

export default MatrixChart;
